export const paymentsTypes = [
  {
    label: "Pendentes",
    value: "PENDENTE",
  },
  {
    label: "Aprovados",
    value: "APROVADO",
  },
  {
    label: "Pago",
    value: "PAGO",
  },
  {
    label: "Recusado",
    value: "RECUSADO"
  }
];
